// THIS CODE WAS AUTO-GENERATED from '/packages/icon/icons/makeSvgsIntoJsx.js'
// PLEASE DO NOT EDIT HERE. EDIT THE FILE THAT MADE THIS
import React from 'react'
import { sanitizeProps } from '@fs/zion-frontend-friends'
import { BaseIcon } from '@fs/zion-icon/BaseIcon'

export default (props) => (
  <BaseIcon {...sanitizeProps(props)}>
    <path d="M22 12a10 10 0 1 0-11.56 9.88v-7H7.9V12h2.54V9.8a3.52 3.52 0 0 1 3.77-3.89 15.27 15.27 0 0 1 2.24.19v2.46h-1.26a1.45 1.45 0 0 0-1.62 1.25 1.61 1.61 0 0 0 0 .31V12h2.78l-.45 2.89h-2.34v7A10 10 0 0 0 22 12Z" />
  </BaseIcon>
)
